const initializedCovers = new WeakSet<HTMLImageElement>()

/**
 * Reveal the neutral placeholder when a marked book cover fails to load.
 *
 * Each cover is initialized once. Covers that failed before initialization are
 * also recovered when the browser reports them as complete with no natural width.
 */
export function initializeBestBooksCoverFallbacks(
  root: ParentNode = document,
): void {
  const covers = root.querySelectorAll<HTMLImageElement>(
    'img[data-best-books-image-fallback="book-cover"]',
  )

  for (const cover of covers) {
    if (initializedCovers.has(cover)) {
      continue
    }
    initializedCovers.add(cover)

    const useFallback = (): void => {
      cover.removeEventListener('error', useFallback)
      cover.hidden = true
      const placeholder = cover.parentElement?.querySelector<HTMLElement>(
        '[data-best-books-cover-placeholder]',
      )
      placeholder?.setAttribute('aria-hidden', 'false')
    }

    cover.addEventListener('error', useFallback)
    if (cover.complete && cover.naturalWidth === 0) {
      useFallback()
    }
  }
}
